import { motion } from "framer-motion";
import { DIFFERENCE, revealUp } from "../../lib/mrs";

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[#121412] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20 border-y border-[#eae7e0]/10"
    >
      <div className="max-w-2xl mb-14 md:mb-20">
        <motion.p
          variants={revealUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-[11px] md:text-sm tracking-[0.28em] uppercase text-[#b89b72] mb-5"
        >
          Why Choose MRS
        </motion.p>
        <motion.h2
          variants={revealUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight"
        >
          Built on transparency, handed over with trust.
        </motion.h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
        {DIFFERENCE.map((d, i) => (
          <motion.div
            key={d.title}
            variants={revealUp}
            custom={i}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-40px" }}
            data-testid={`difference-card-${i}`}
            className={`group relative bg-[#0a0b0a] border border-[#eae7e0]/10 p-8 md:p-10 lg:p-12 transition-all duration-500 hover:border-[#b89b72]/40 ${d.span}`}
          >
            <div className="flex items-start gap-5">
              <span className="font-num text-[#b89b72] text-xl md:text-2xl leading-none pt-1">
                0{i + 1}
              </span>
              <div>
                <h3 className="font-display text-2xl md:text-3xl lg:text-4xl font-normal text-[#eae7e0] mb-3">
                  {d.title}
                </h3>
                <p className="text-sm md:text-base text-[#9ca399] leading-relaxed max-w-md">
                  {d.desc}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
